import { ModelBase } from "../shared/model.base";
import { TableColumns } from "../../decorators/shared/table-columns.decorator";
import { ColumnTitle } from "../../decorators/shared/column-title.decorator";
import { ColumnType } from "../../decorators/shared/column-type.decorator";
import { DataType } from "../../enums/shared/enums";

// @TableColumns
export class Company extends ModelBase {
    id: number;

    @ColumnTitle("Nombre")
    name: "";

    @ColumnTitle("Ruc")
    ruc: "";

    @ColumnTitle("Activo")
    @ColumnType(DataType.boolean)
    isActive: boolean;

    @ColumnTitle("Correo")
    email: "";
    @ColumnTitle("Número de teléfono")
    callCenterNumber: "";
    @ColumnTitle("Dirección  de la empresa")
    companyAddress: "";

    url: string;
    urlEcommerce: string;

    userId: string;

    isSaaSOwner: boolean;

    company_parent_id: number;

    constructor() {
        super();

        this.name = "";
        this.email = "";
        this.ruc = "";
        this.callCenterNumber = "";
        this.companyAddress = "";
        this.isActive = true;
        this.userId = "";
        this.isSaaSOwner = false;
        this.company_parent_id = null;
    }
}
